<p-dialog header="{{ 'ReceiptFormGenerateCost.GenerateCostReport' | translate }}" [(visible)]="display" appendTo="body" (onHide)="hideDialog($event)" [modal]="true" [style]="{'width': '80vw'}">
  <div *ngIf="isSaveBillingLoading" class="loading-overlay">
    <p-progressSpinner></p-progressSpinner>
  </div>
  <p-table class="datatable" [value]="this.previewBeans" [columns]="columns" dataKey="headerEntity.rfqseqNo" [loading]="isLoading" [resizableColumns]="true">
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th *ngFor="let col of columns">
          {{col.header | translate}}
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rows let-columns="columns">
      <tr *ngIf="rows.detailEntities.length > 0">
        <td [attr.rowspan]="rows.detailEntities.length">

          <p-radioButton [inputId]="rows.headerEntity.seqNo" name="category" [value]="rows"
            [(ngModel)]="selectedCategory" *ngIf="!isMultipleRfqChoose"></p-radioButton>

          <p-checkbox [inputId]="rows.headerEntity.seqNo" name="category" [value]="rows"
            [(ngModel)]="selectedCategories" *ngIf="isMultipleRfqChoose"></p-checkbox>

        </td>
        <td [attr.rowspan]="rows.detailEntities.length">{{rows.headerEntity.currency}}</td>
        <td [attr.rowspan]="rows.detailEntities.length">{{rows.headerEntity.estimateTotalCharge}}</td>
        <td><div class="overflow-text">{{rows.detailEntities[0].feeTypeLabel}}</div></td>
        <td><div class="overflow-text">{{rows.detailEntities[0].accountCodeLabel}}</div></td>
        <td><div class="overflow-text">{{rows.detailEntities[0].shippingTypeLabel}}</div></td>
        <td><div class="overflow-text">{{rows.detailEntities[0].shippingSectionDesc}}</div></td>
        <td><div class="overflow-text">{{rows.detailEntities[0].estimatedAmountDesc}}</div></td>

        <td><div class="overflow-text">{{rows.detailEntities[0].estimatedAmount}}</div></td>
        <td><div class="overflow-text">{{rows.detailEntities[0].preCurrencyCode}}</div></td>
        <td><div class="overflow-text">{{rows.detailEntities[0].rate}}</div></td>

        <!--<td>{{rowData.createDt | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}</td>-->
      </tr>
      <tr *ngFor="let detailEntity of rows.detailEntities.slice(1)">
        <td><div class="overflow-text">{{detailEntity.feeTypeLabel}}</div></td>
        <td><div class="overflow-text">{{detailEntity.accountCodeLabel}}</div></td>
        <td><div class="overflow-text">{{detailEntity.shippingTypeLabel}}</div></td>
        <td><div class="overflow-text">{{detailEntity.shippingSectionDesc}}</div></td>
        <td><div class="overflow-text">{{detailEntity.estimatedAmountDesc}}</div></td>

        <td><div class="overflow-text">{{detailEntity.estimatedAmount}}</div></td>
        <td><div class="overflow-text">{{detailEntity.preCurrencyCode}}</div></td>
        <td><div class="overflow-text">{{detailEntity.rate}}</div></td>

      </tr>
    </ng-template>
  </p-table>
  <div>
    <button (click)="save()" pButton pRipple label="{{ 'Common.Button.Confirm' | translate }}"
      [disabled]="selectedCategory == null && selectedCategories.length == 0"></button>
  </div>
</p-dialog>
